import { GET_PROJECT_LIST } from '../actionTypes';


const defaultState = {    
    allProjects:[]
}
export default (state=defaultState, action)=>{
    switch (action.type) {
      case GET_PROJECT_LIST:
        return { ...state, allProjects: (action.payload||[]) };
    default:
        return state;
    }
}